import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Candidate } from 'app/shared/models/candidate.model';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-task-view',
  templateUrl: './task-view.component.html',
  styleUrls: ['./task-view.component.scss']
})
export class TaskViewComponent implements OnInit {
  task_id:any
  task:any
  currentUrl:any
  candidate_model = new Candidate()
 constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
  this.currentUrl=this.activatedroute.snapshot.routeConfig.path
  console.log('',this.currentUrl)
     this.activatedroute.paramMap.subscribe(params => { 
       this.task_id = params.get('id'); 
       if(this.currentUrl ==='task-view/:id'){
        this.getTask(this.task_id)
       }
       if(this.currentUrl ==='candidate-view/:id'){
        this.getCandidateById(this.task_id)
       }
       
   });
 
   }
 
   ngOnInit(): void {
     
   }
   getTask(id){
     this.apiService.getTaskById(id).subscribe((res:any)=>{
         this.task_id =res.data[0] 
     })
   }
   getCandidateById(id){
    this.apiService.getCandidatesById(id).subscribe((res:any)=>{
        this.candidate_model=res?.data

    })
  }
}
